import React from "react";

import classes from "./Header.module.css";

export default function Form(props) {
  let class_name = [classes.Form];
  if (props.onlyDesktop) class_name.push(classes.OnlyDesktop);
  class_name = class_name.join(" ");
  let style = {};
  if (props.style) style = { ...props.style };
  return (
    <form onSubmit={props.onSubmit} className={class_name}>
      <input
        type="text"
        placeholder="Search"
        value={props.value}
        onChange={props.onChange}
        style={style}
      />
      <button>
        <i className="fas fa-search" />
      </button>
    </form>
  );
}
